import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconClipboardOut12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconClipboardOut12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3.085 1A1.5 1.5 0 0 1 4.5 0h2a1.5 1.5 0 0 1 1.415 1H8.5A1.5 1.5 0 0 1 10 2.5V5H9V2.5a.5.5 0 0 0-.5-.5h-.585A1.5 1.5 0 0 1 6.5 3h-2a1.5 1.5 0 0 1-1.415-1H2.5a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5H4v1H2.5A1.5 1.5 0 0 1 1 9.5v-7A1.5 1.5 0 0 1 2.5 1zM4 1.5a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 0-1h-2a.5.5 0 0 0-.5.5m1.146 4.646a.5.5 0 0 1 .708 0L10 10.293V7.5a.5.5 0 0 1 1 0V12H6.5a.5.5 0 0 1 0-1h2.793L5.146 6.854a.5.5 0 0 1 0-.708"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconClipboardOut12);
